import React from 'react';

/**
 * AppErrorBoundary — catches any uncaught render error anywhere below it and
 * shows a friendly recovery screen instead of a blank white page.
 * The user can reload, or jump back to their role's dashboard.
 */
class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info?.componentStack);
  }

  handleReload = () => window.location.reload();

  handleGoHome = () => {
    this.setState({ hasError: false, error: null });
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const home = {
      admin: '/admin-dashboard',
      system_admin: '/admin-dashboard',
      support: '/admin-dashboard',
      university: '/uni-dashboard',
      student: '/student-dashboard',
      faculty: '/faculty-dashboard',
      tpo: '/tpo-dashboard',
      pop: '/pop-dashboard',
    }[user.role] || '/login';
    window.location.href = home;
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '70vh', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', gap: '18px',
          padding: '40px 20px', textAlign: 'center',
        }}>
          <div style={{ fontSize: '44px' }}>⚠️</div>
          <h2 style={{ margin: 0, color: 'var(--text-primary, #1a1a2e)' }}>
            Something went wrong
          </h2>
          <p style={{ margin: 0, maxWidth: '480px', color: 'var(--text-secondary, #555)' }}>
            This page hit an unexpected error. Reloading usually fixes it.
            If it keeps happening, head back to your dashboard.
          </p>
          <div style={{ display: 'flex', gap: '12px', marginTop: '6px' }}>
            <button
              onClick={this.handleReload}
              style={{
                padding: '10px 22px', borderRadius: '8px', border: 'none',
                background: 'var(--primary, #4f46e5)', color: '#fff',
                fontWeight: 600, cursor: 'pointer',
              }}
            >
              Reload page
            </button>
            <button
              onClick={this.handleGoHome}
              style={{
                padding: '10px 22px', borderRadius: '8px',
                border: '1px solid var(--border, #ddd)', background: 'transparent',
                color: 'var(--text-primary, #1a1a2e)', fontWeight: 600, cursor: 'pointer',
              }}
            >
              Go to dashboard
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default AppErrorBoundary;
